import type { ReactNode } from "react"

import type { Nav } from "@/lib/hooks"

export function Link({ to, nav, children }: { to: string; nav: Nav; children: ReactNode }) {
  return (
    <button
      className="text-inherit underline decoration-dotted underline-offset-4 hover:opacity-70"
      onClick={() => nav(to)}
    >
      {children}
    </button>
  )
}
